import { render, staticRenderFns } from "./ModalTerms.vue?vue&type=template&id=1a811d86&"
import script from "./ModalTerms.vue?vue&type=script&lang=js&"
export * from "./ModalTerms.vue?vue&type=script&lang=js&"
import style0 from "./ModalTerms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports